@let classifications = menuClassifications$ | async;
@let badges = menuBadges$ | async | filterList: removePLKeywordBadges;
<!-- this prevents empty footers from causing 35k page render bug -->
@let canFlex = classifications?.length > 0 && badges?.length > 0;
<div
  class="footer-container"
  #footerContainer
  [style.display]="canFlex ? 'flex' : null"
  [ngClass]="menu | method: 'getFooterWrapperClass'"
  [style.color]="menu?.hydratedTheme?.themeFeatures?.footerTextColor ? menu?.menuOptions?.footerTextColor : ''">
  @if (classifications?.length > 0) {
    <div class="classification-container">
      <div *ngFor="let classification of classifications" class="classification-mapping">
        <div class="classification-badge" [ngClass]="classification | lowercase">
          {{ classification | getClassificationSymbol }}
        </div>
        <span class="classification-name"> = {{ classification | uppercase }} </span>
      </div>
    </div>
  }
  @if (badges?.length > 0) {
    <div class="footer-badge-container">
      <div *ngFor="let badge of badges; trackBy: trackByBadgeUniqueIdentifier" class="badge-container">
        <img appImage class="footer-badge" [asset]="badge?.image" [reset]="reset" alt="badge" src="" />
        <div class="footer-badge-title">= {{ badge?.name | uppercase | replace: '\\[PL\\]' : '' | trimSafely }}</div>
      </div>
    </div>
  }
</div>
